export default __webpack_public_path__ + "static/media/logo_grupo.5d8c5b2b.png";